module.exports = __webpack_public_path__ + "static/footer-pattern-bar-aaee33096dff21253671b0755ad8f941.svg";